export default "__VITE_ASSET__BA$VqYer__"